import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DocxDialog, type DocxDialogData } from './docx-dialog';

const DIALOG_WIDTH = '95vw';
const DIALOG_HEIGHT = '90vh';

@Injectable({ providedIn: 'root' })
export class DocxPreview {
  private readonly dialog = inject(MatDialog);

  public open(data: DocxDialogData): MatDialogRef<DocxDialog> {
    return this.dialog.open(DocxDialog, {
      data,
      width: DIALOG_WIDTH,
      maxWidth: DIALOG_WIDTH,
      height: DIALOG_HEIGHT,
      autoFocus: false,
    });
  }
}
